import { render, staticRenderFns } from "./PaletteOutline.vue?vue&type=template&id=1b51fffe"
import script from "./PaletteOutline.vue?vue&type=script&lang=js"
export * from "./PaletteOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports